export default {
    created() {
        window.AppEventBus.$on('editorChanged', (props) => {
            this[props.prop] = props.value;
        });
    },
};



// WEBPACK FOOTER //
// ./resources/js/admin-panel/components/admin/mixins.js